/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeOpen12: {
  name: 'eye-open-12';
  data: string;
} = {
  name: 'eye-open-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5.99 1.5c1.973 0 3.873 1.197 5.7 3.59a1.5 1.5 0 0 1 .073 1.717l-.073.103-.183.236C9.737 9.382 7.897 10.5 5.99 10.5c-1.975 0-3.87-1.198-5.686-3.594A1.5 1.5 0 0 1 .23 5.204l.075-.11.182-.236C2.246 2.62 4.081 1.5 5.99 1.5zM6 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm.002 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"/></svg>`
};
